import React from 'react'
import styles from "./Spinner.module.css"

const Spinner = ({ color = null, size = 24 }) => {
  return (
    <span
      className={styles.spinner}
      style={{
        color,
        width: size,
        height: size,
      }}
    />
  )
}

export default Spinner